// extracted by mini-css-extract-plugin
export var centerText = "_5h-8";
export var container = "_5h-0";
export var doughnutContainer = "_5h-7";
export var legend = "_5h-a";
export var legendItemColorDisplay = "_5h-b";
export var legendItemLabel = "_5h-d";
export var legendItemValue = "_5h-c";
export var lg = "_5h-5";
export var maxWidth = "_5h-9";
export var md = "_5h-4";
export var responsive = "_5h-6";
export var sm = "_5h-3";
export var xs = "_5h-2";
export var xxs = "_5h-1";